/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedResourcesRouteImport } from './routes/_authed/resources'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedMcpSetupRouteImport } from './routes/_authed/mcp-setup'
import { Route as AuthedFavoritesRouteImport } from './routes/_authed/favorites'
import { Route as AuthedDashboardsRouteImport } from './routes/_authed/dashboards'
import { Route as AuthedAnnouncementsRouteImport } from './routes/_authed/announcements'
import { Route as AuthedActivityRouteImport } from './routes/_authed/activity'
import { Route as AuthedMetricHubIndexRouteImport } from './routes/_authed/metric-hub/index'
import { Route as AuthedMetricHubSyncDashboardRouteImport } from './routes/_authed/metric-hub/sync-dashboard'
import { Route as AuthedMetricHubPreviewAccessRouteImport } from './routes/_authed/metric-hub/preview-access'
import { Route as AuthedMetricHubPolicyRouteImport } from './routes/_authed/metric-hub/policy'
import { Route as AuthedMetricHubOnboardingRouteImport } from './routes/_authed/metric-hub/onboarding'
import { Route as AuthedMetricHubMyDraftsRouteImport } from './routes/_authed/metric-hub/my-drafts'
import { Route as AuthedMetricHubInboxRouteImport } from './routes/_authed/metric-hub/inbox'
import { Route as AuthedMetricHubHealthRouteImport } from './routes/_authed/metric-hub/health'
import { Route as AuthedMetricHubGraphRouteImport } from './routes/_authed/metric-hub/graph'
import { Route as AuthedMetricHubGlossaryRouteImport } from './routes/_authed/metric-hub/glossary'
import { Route as AuthedMetricHubDocsRouteImport } from './routes/_authed/metric-hub/docs'
import { Route as AuthedMetricHubDashboardRouteImport } from './routes/_authed/metric-hub/dashboard'
import { Route as AuthedMetricHubCertificateRouteImport } from './routes/_authed/metric-hub/certificate'
import { Route as AuthedMetricHubAdoptionRouteImport } from './routes/_authed/metric-hub/adoption'
import { Route as AuthedAdminWebhookLogsRouteImport } from './routes/_authed/admin/webhook-logs'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedAdminTokensRouteImport } from './routes/_authed/admin/tokens'
import { Route as AuthedAdminEmbeddingsRouteImport } from './routes/_authed/admin/embeddings'
import { Route as AuthedAdminCategoriesRouteImport } from './routes/_authed/admin/categories'
import { Route as AuthedAdminAtlasRouteImport } from './routes/_authed/admin/atlas'
import { Route as AuthedMetricHubSemanticModelsIndexRouteImport } from './routes/_authed/metric-hub/semantic-models.index'
import { Route as AuthedMetricHubExploreIndexRouteImport } from './routes/_authed/metric-hub/explore.index'
import { Route as AuthedMetricHubSemanticModelsNewRouteImport } from './routes/_authed/metric-hub/semantic-models.new'
import { Route as AuthedMetricHubSemanticModelsNameRouteImport } from './routes/_authed/metric-hub/semantic-models.$name'
import { Route as AuthedMetricHubMetricsNewRouteImport } from './routes/_authed/metric-hub/metrics.new'
import { Route as AuthedMetricHubMetricsSlugRouteImport } from './routes/_authed/metric-hub/metrics.$slug'
import { Route as AuthedMetricHubExploreBoardIdRouteImport } from './routes/_authed/metric-hub/explore.$boardId'
import { Route as AuthedMetricHubSemanticModelsNameProposeVersionRouteImport } from './routes/_authed/metric-hub/semantic-models.$name_.propose-version'
import { Route as AuthedMetricHubDraftsSlugDraftIdRouteImport } from './routes/_authed/metric-hub/drafts.$slug.$draftId'
import { Route as AuthedMetricHubDraftsSlugDraftIdIndexRouteImport } from './routes/_authed/metric-hub/drafts.$slug.$draftId.index'
import { Route as AuthedMetricHubDraftsSlugDraftIdEditRouteImport } from './routes/_authed/metric-hub/drafts.$slug.$draftId.edit'
import { Route as AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRouteImport } from './routes/_authed/metric-hub/semantic-models.$name_.drafts.$draftId.index'
import { Route as AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRouteImport } from './routes/_authed/metric-hub/semantic-models.$name_.drafts.$draftId.edit'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedResourcesRoute = AuthedResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMcpSetupRoute = AuthedMcpSetupRouteImport.update({
  id: '/mcp-setup',
  path: '/mcp-setup',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFavoritesRoute = AuthedFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardsRoute = AuthedDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsRoute = AuthedAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedActivityRoute = AuthedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubIndexRoute = AuthedMetricHubIndexRouteImport.update({
  id: '/metric-hub/',
  path: '/metric-hub/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubSyncDashboardRoute =
  AuthedMetricHubSyncDashboardRouteImport.update({
    id: '/metric-hub/sync-dashboard',
    path: '/metric-hub/sync-dashboard',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubPreviewAccessRoute =
  AuthedMetricHubPreviewAccessRouteImport.update({
    id: '/metric-hub/preview-access',
    path: '/metric-hub/preview-access',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubPolicyRoute = AuthedMetricHubPolicyRouteImport.update({
  id: '/metric-hub/policy',
  path: '/metric-hub/policy',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubOnboardingRoute =
  AuthedMetricHubOnboardingRouteImport.update({
    id: '/metric-hub/onboarding',
    path: '/metric-hub/onboarding',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubMyDraftsRoute = AuthedMetricHubMyDraftsRouteImport.update({
  id: '/metric-hub/my-drafts',
  path: '/metric-hub/my-drafts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubInboxRoute = AuthedMetricHubInboxRouteImport.update({
  id: '/metric-hub/inbox',
  path: '/metric-hub/inbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubHealthRoute = AuthedMetricHubHealthRouteImport.update({
  id: '/metric-hub/health',
  path: '/metric-hub/health',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubGraphRoute = AuthedMetricHubGraphRouteImport.update({
  id: '/metric-hub/graph',
  path: '/metric-hub/graph',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubGlossaryRoute = AuthedMetricHubGlossaryRouteImport.update({
  id: '/metric-hub/glossary',
  path: '/metric-hub/glossary',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubDocsRoute = AuthedMetricHubDocsRouteImport.update({
  id: '/metric-hub/docs',
  path: '/metric-hub/docs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubDashboardRoute =
  AuthedMetricHubDashboardRouteImport.update({
    id: '/metric-hub/dashboard',
    path: '/metric-hub/dashboard',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubCertificateRoute =
  AuthedMetricHubCertificateRouteImport.update({
    id: '/metric-hub/certificate',
    path: '/metric-hub/certificate',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubAdoptionRoute = AuthedMetricHubAdoptionRouteImport.update({
  id: '/metric-hub/adoption',
  path: '/metric-hub/adoption',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminWebhookLogsRoute = AuthedAdminWebhookLogsRouteImport.update({
  id: '/admin/webhook-logs',
  path: '/admin/webhook-logs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminTokensRoute = AuthedAdminTokensRouteImport.update({
  id: '/admin/tokens',
  path: '/admin/tokens',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminEmbeddingsRoute = AuthedAdminEmbeddingsRouteImport.update({
  id: '/admin/embeddings',
  path: '/admin/embeddings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminCategoriesRoute = AuthedAdminCategoriesRouteImport.update({
  id: '/admin/categories',
  path: '/admin/categories',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminAtlasRoute = AuthedAdminAtlasRouteImport.update({
  id: '/admin/atlas',
  path: '/admin/atlas',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetricHubSemanticModelsIndexRoute =
  AuthedMetricHubSemanticModelsIndexRouteImport.update({
    id: '/metric-hub/semantic-models/',
    path: '/metric-hub/semantic-models/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubExploreIndexRoute =
  AuthedMetricHubExploreIndexRouteImport.update({
    id: '/metric-hub/explore/',
    path: '/metric-hub/explore/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubSemanticModelsNewRoute =
  AuthedMetricHubSemanticModelsNewRouteImport.update({
    id: '/metric-hub/semantic-models/new',
    path: '/metric-hub/semantic-models/new',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubSemanticModelsNameRoute =
  AuthedMetricHubSemanticModelsNameRouteImport.update({
    id: '/metric-hub/semantic-models/$name',
    path: '/metric-hub/semantic-models/$name',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubMetricsNewRoute =
  AuthedMetricHubMetricsNewRouteImport.update({
    id: '/metric-hub/metrics/new',
    path: '/metric-hub/metrics/new',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubMetricsSlugRoute =
  AuthedMetricHubMetricsSlugRouteImport.update({
    id: '/metric-hub/metrics/$slug',
    path: '/metric-hub/metrics/$slug',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubExploreBoardIdRoute =
  AuthedMetricHubExploreBoardIdRouteImport.update({
    id: '/metric-hub/explore/$boardId',
    path: '/metric-hub/explore/$boardId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubSemanticModelsNameProposeVersionRoute =
  AuthedMetricHubSemanticModelsNameProposeVersionRouteImport.update({
    id: '/metric-hub/semantic-models/$name_/propose-version',
    path: '/metric-hub/semantic-models/$name/propose-version',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubDraftsSlugDraftIdRoute =
  AuthedMetricHubDraftsSlugDraftIdRouteImport.update({
    id: '/metric-hub/drafts/$slug/$draftId',
    path: '/metric-hub/drafts/$slug/$draftId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubDraftsSlugDraftIdIndexRoute =
  AuthedMetricHubDraftsSlugDraftIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedMetricHubDraftsSlugDraftIdRoute,
  } as any)
const AuthedMetricHubDraftsSlugDraftIdEditRoute =
  AuthedMetricHubDraftsSlugDraftIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthedMetricHubDraftsSlugDraftIdRoute,
  } as any)
const AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute =
  AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRouteImport.update({
    id: '/metric-hub/semantic-models/$name_/drafts/$draftId/',
    path: '/metric-hub/semantic-models/$name/drafts/$draftId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute =
  AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRouteImport.update({
    id: '/metric-hub/semantic-models/$name_/drafts/$draftId/edit',
    path: '/metric-hub/semantic-models/$name/drafts/$draftId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/sign-in': typeof SignInRoute
  '/activity': typeof AuthedActivityRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/dashboards': typeof AuthedDashboardsRoute
  '/favorites': typeof AuthedFavoritesRoute
  '/mcp-setup': typeof AuthedMcpSetupRoute
  '/profile': typeof AuthedProfileRoute
  '/resources': typeof AuthedResourcesRoute
  '/settings': typeof AuthedSettingsRoute
  '/admin/atlas': typeof AuthedAdminAtlasRoute
  '/admin/categories': typeof AuthedAdminCategoriesRoute
  '/admin/embeddings': typeof AuthedAdminEmbeddingsRoute
  '/admin/tokens': typeof AuthedAdminTokensRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/admin/webhook-logs': typeof AuthedAdminWebhookLogsRoute
  '/metric-hub/adoption': typeof AuthedMetricHubAdoptionRoute
  '/metric-hub/certificate': typeof AuthedMetricHubCertificateRoute
  '/metric-hub/dashboard': typeof AuthedMetricHubDashboardRoute
  '/metric-hub/docs': typeof AuthedMetricHubDocsRoute
  '/metric-hub/glossary': typeof AuthedMetricHubGlossaryRoute
  '/metric-hub/graph': typeof AuthedMetricHubGraphRoute
  '/metric-hub/health': typeof AuthedMetricHubHealthRoute
  '/metric-hub/inbox': typeof AuthedMetricHubInboxRoute
  '/metric-hub/my-drafts': typeof AuthedMetricHubMyDraftsRoute
  '/metric-hub/onboarding': typeof AuthedMetricHubOnboardingRoute
  '/metric-hub/policy': typeof AuthedMetricHubPolicyRoute
  '/metric-hub/preview-access': typeof AuthedMetricHubPreviewAccessRoute
  '/metric-hub/sync-dashboard': typeof AuthedMetricHubSyncDashboardRoute
  '/metric-hub/': typeof AuthedMetricHubIndexRoute
  '/metric-hub/explore/$boardId': typeof AuthedMetricHubExploreBoardIdRoute
  '/metric-hub/metrics/$slug': typeof AuthedMetricHubMetricsSlugRoute
  '/metric-hub/metrics/new': typeof AuthedMetricHubMetricsNewRoute
  '/metric-hub/semantic-models/$name': typeof AuthedMetricHubSemanticModelsNameRoute
  '/metric-hub/semantic-models/new': typeof AuthedMetricHubSemanticModelsNewRoute
  '/metric-hub/explore/': typeof AuthedMetricHubExploreIndexRoute
  '/metric-hub/semantic-models/': typeof AuthedMetricHubSemanticModelsIndexRoute
  '/metric-hub/drafts/$slug/$draftId': typeof AuthedMetricHubDraftsSlugDraftIdRouteWithChildren
  '/metric-hub/semantic-models/$name/propose-version': typeof AuthedMetricHubSemanticModelsNameProposeVersionRoute
  '/metric-hub/drafts/$slug/$draftId/edit': typeof AuthedMetricHubDraftsSlugDraftIdEditRoute
  '/metric-hub/drafts/$slug/$draftId/': typeof AuthedMetricHubDraftsSlugDraftIdIndexRoute
  '/metric-hub/semantic-models/$name/drafts/$draftId/edit': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute
  '/metric-hub/semantic-models/$name/drafts/$draftId/': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/activity': typeof AuthedActivityRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/dashboards': typeof AuthedDashboardsRoute
  '/favorites': typeof AuthedFavoritesRoute
  '/mcp-setup': typeof AuthedMcpSetupRoute
  '/profile': typeof AuthedProfileRoute
  '/resources': typeof AuthedResourcesRoute
  '/settings': typeof AuthedSettingsRoute
  '/': typeof AuthedIndexRoute
  '/admin/atlas': typeof AuthedAdminAtlasRoute
  '/admin/categories': typeof AuthedAdminCategoriesRoute
  '/admin/embeddings': typeof AuthedAdminEmbeddingsRoute
  '/admin/tokens': typeof AuthedAdminTokensRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/admin/webhook-logs': typeof AuthedAdminWebhookLogsRoute
  '/metric-hub/adoption': typeof AuthedMetricHubAdoptionRoute
  '/metric-hub/certificate': typeof AuthedMetricHubCertificateRoute
  '/metric-hub/dashboard': typeof AuthedMetricHubDashboardRoute
  '/metric-hub/docs': typeof AuthedMetricHubDocsRoute
  '/metric-hub/glossary': typeof AuthedMetricHubGlossaryRoute
  '/metric-hub/graph': typeof AuthedMetricHubGraphRoute
  '/metric-hub/health': typeof AuthedMetricHubHealthRoute
  '/metric-hub/inbox': typeof AuthedMetricHubInboxRoute
  '/metric-hub/my-drafts': typeof AuthedMetricHubMyDraftsRoute
  '/metric-hub/onboarding': typeof AuthedMetricHubOnboardingRoute
  '/metric-hub/policy': typeof AuthedMetricHubPolicyRoute
  '/metric-hub/preview-access': typeof AuthedMetricHubPreviewAccessRoute
  '/metric-hub/sync-dashboard': typeof AuthedMetricHubSyncDashboardRoute
  '/metric-hub': typeof AuthedMetricHubIndexRoute
  '/metric-hub/explore/$boardId': typeof AuthedMetricHubExploreBoardIdRoute
  '/metric-hub/metrics/$slug': typeof AuthedMetricHubMetricsSlugRoute
  '/metric-hub/metrics/new': typeof AuthedMetricHubMetricsNewRoute
  '/metric-hub/semantic-models/$name': typeof AuthedMetricHubSemanticModelsNameRoute
  '/metric-hub/semantic-models/new': typeof AuthedMetricHubSemanticModelsNewRoute
  '/metric-hub/explore': typeof AuthedMetricHubExploreIndexRoute
  '/metric-hub/semantic-models': typeof AuthedMetricHubSemanticModelsIndexRoute
  '/metric-hub/semantic-models/$name/propose-version': typeof AuthedMetricHubSemanticModelsNameProposeVersionRoute
  '/metric-hub/drafts/$slug/$draftId/edit': typeof AuthedMetricHubDraftsSlugDraftIdEditRoute
  '/metric-hub/drafts/$slug/$draftId': typeof AuthedMetricHubDraftsSlugDraftIdIndexRoute
  '/metric-hub/semantic-models/$name/drafts/$draftId/edit': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute
  '/metric-hub/semantic-models/$name/drafts/$draftId': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authed/activity': typeof AuthedActivityRoute
  '/_authed/announcements': typeof AuthedAnnouncementsRoute
  '/_authed/dashboards': typeof AuthedDashboardsRoute
  '/_authed/favorites': typeof AuthedFavoritesRoute
  '/_authed/mcp-setup': typeof AuthedMcpSetupRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/resources': typeof AuthedResourcesRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/atlas': typeof AuthedAdminAtlasRoute
  '/_authed/admin/categories': typeof AuthedAdminCategoriesRoute
  '/_authed/admin/embeddings': typeof AuthedAdminEmbeddingsRoute
  '/_authed/admin/tokens': typeof AuthedAdminTokensRoute
  '/_authed/admin/users': typeof AuthedAdminUsersRoute
  '/_authed/admin/webhook-logs': typeof AuthedAdminWebhookLogsRoute
  '/_authed/metric-hub/adoption': typeof AuthedMetricHubAdoptionRoute
  '/_authed/metric-hub/certificate': typeof AuthedMetricHubCertificateRoute
  '/_authed/metric-hub/dashboard': typeof AuthedMetricHubDashboardRoute
  '/_authed/metric-hub/docs': typeof AuthedMetricHubDocsRoute
  '/_authed/metric-hub/glossary': typeof AuthedMetricHubGlossaryRoute
  '/_authed/metric-hub/graph': typeof AuthedMetricHubGraphRoute
  '/_authed/metric-hub/health': typeof AuthedMetricHubHealthRoute
  '/_authed/metric-hub/inbox': typeof AuthedMetricHubInboxRoute
  '/_authed/metric-hub/my-drafts': typeof AuthedMetricHubMyDraftsRoute
  '/_authed/metric-hub/onboarding': typeof AuthedMetricHubOnboardingRoute
  '/_authed/metric-hub/policy': typeof AuthedMetricHubPolicyRoute
  '/_authed/metric-hub/preview-access': typeof AuthedMetricHubPreviewAccessRoute
  '/_authed/metric-hub/sync-dashboard': typeof AuthedMetricHubSyncDashboardRoute
  '/_authed/metric-hub/': typeof AuthedMetricHubIndexRoute
  '/_authed/metric-hub/explore/$boardId': typeof AuthedMetricHubExploreBoardIdRoute
  '/_authed/metric-hub/metrics/$slug': typeof AuthedMetricHubMetricsSlugRoute
  '/_authed/metric-hub/metrics/new': typeof AuthedMetricHubMetricsNewRoute
  '/_authed/metric-hub/semantic-models/$name': typeof AuthedMetricHubSemanticModelsNameRoute
  '/_authed/metric-hub/semantic-models/new': typeof AuthedMetricHubSemanticModelsNewRoute
  '/_authed/metric-hub/explore/': typeof AuthedMetricHubExploreIndexRoute
  '/_authed/metric-hub/semantic-models/': typeof AuthedMetricHubSemanticModelsIndexRoute
  '/_authed/metric-hub/drafts/$slug/$draftId': typeof AuthedMetricHubDraftsSlugDraftIdRouteWithChildren
  '/_authed/metric-hub/semantic-models/$name_/propose-version': typeof AuthedMetricHubSemanticModelsNameProposeVersionRoute
  '/_authed/metric-hub/drafts/$slug/$draftId/edit': typeof AuthedMetricHubDraftsSlugDraftIdEditRoute
  '/_authed/metric-hub/drafts/$slug/$draftId/': typeof AuthedMetricHubDraftsSlugDraftIdIndexRoute
  '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/edit': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute
  '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/': typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/activity'
    | '/announcements'
    | '/dashboards'
    | '/favorites'
    | '/mcp-setup'
    | '/profile'
    | '/resources'
    | '/settings'
    | '/admin/atlas'
    | '/admin/categories'
    | '/admin/embeddings'
    | '/admin/tokens'
    | '/admin/users'
    | '/admin/webhook-logs'
    | '/metric-hub/adoption'
    | '/metric-hub/certificate'
    | '/metric-hub/dashboard'
    | '/metric-hub/docs'
    | '/metric-hub/glossary'
    | '/metric-hub/graph'
    | '/metric-hub/health'
    | '/metric-hub/inbox'
    | '/metric-hub/my-drafts'
    | '/metric-hub/onboarding'
    | '/metric-hub/policy'
    | '/metric-hub/preview-access'
    | '/metric-hub/sync-dashboard'
    | '/metric-hub/'
    | '/metric-hub/explore/$boardId'
    | '/metric-hub/metrics/$slug'
    | '/metric-hub/metrics/new'
    | '/metric-hub/semantic-models/$name'
    | '/metric-hub/semantic-models/new'
    | '/metric-hub/explore/'
    | '/metric-hub/semantic-models/'
    | '/metric-hub/drafts/$slug/$draftId'
    | '/metric-hub/semantic-models/$name/propose-version'
    | '/metric-hub/drafts/$slug/$draftId/edit'
    | '/metric-hub/drafts/$slug/$draftId/'
    | '/metric-hub/semantic-models/$name/drafts/$draftId/edit'
    | '/metric-hub/semantic-models/$name/drafts/$draftId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/activity'
    | '/announcements'
    | '/dashboards'
    | '/favorites'
    | '/mcp-setup'
    | '/profile'
    | '/resources'
    | '/settings'
    | '/'
    | '/admin/atlas'
    | '/admin/categories'
    | '/admin/embeddings'
    | '/admin/tokens'
    | '/admin/users'
    | '/admin/webhook-logs'
    | '/metric-hub/adoption'
    | '/metric-hub/certificate'
    | '/metric-hub/dashboard'
    | '/metric-hub/docs'
    | '/metric-hub/glossary'
    | '/metric-hub/graph'
    | '/metric-hub/health'
    | '/metric-hub/inbox'
    | '/metric-hub/my-drafts'
    | '/metric-hub/onboarding'
    | '/metric-hub/policy'
    | '/metric-hub/preview-access'
    | '/metric-hub/sync-dashboard'
    | '/metric-hub'
    | '/metric-hub/explore/$boardId'
    | '/metric-hub/metrics/$slug'
    | '/metric-hub/metrics/new'
    | '/metric-hub/semantic-models/$name'
    | '/metric-hub/semantic-models/new'
    | '/metric-hub/explore'
    | '/metric-hub/semantic-models'
    | '/metric-hub/semantic-models/$name/propose-version'
    | '/metric-hub/drafts/$slug/$draftId/edit'
    | '/metric-hub/drafts/$slug/$draftId'
    | '/metric-hub/semantic-models/$name/drafts/$draftId/edit'
    | '/metric-hub/semantic-models/$name/drafts/$draftId'
  id:
    | '__root__'
    | '/_authed'
    | '/sign-in'
    | '/_authed/activity'
    | '/_authed/announcements'
    | '/_authed/dashboards'
    | '/_authed/favorites'
    | '/_authed/mcp-setup'
    | '/_authed/profile'
    | '/_authed/resources'
    | '/_authed/settings'
    | '/_authed/'
    | '/_authed/admin/atlas'
    | '/_authed/admin/categories'
    | '/_authed/admin/embeddings'
    | '/_authed/admin/tokens'
    | '/_authed/admin/users'
    | '/_authed/admin/webhook-logs'
    | '/_authed/metric-hub/adoption'
    | '/_authed/metric-hub/certificate'
    | '/_authed/metric-hub/dashboard'
    | '/_authed/metric-hub/docs'
    | '/_authed/metric-hub/glossary'
    | '/_authed/metric-hub/graph'
    | '/_authed/metric-hub/health'
    | '/_authed/metric-hub/inbox'
    | '/_authed/metric-hub/my-drafts'
    | '/_authed/metric-hub/onboarding'
    | '/_authed/metric-hub/policy'
    | '/_authed/metric-hub/preview-access'
    | '/_authed/metric-hub/sync-dashboard'
    | '/_authed/metric-hub/'
    | '/_authed/metric-hub/explore/$boardId'
    | '/_authed/metric-hub/metrics/$slug'
    | '/_authed/metric-hub/metrics/new'
    | '/_authed/metric-hub/semantic-models/$name'
    | '/_authed/metric-hub/semantic-models/new'
    | '/_authed/metric-hub/explore/'
    | '/_authed/metric-hub/semantic-models/'
    | '/_authed/metric-hub/drafts/$slug/$draftId'
    | '/_authed/metric-hub/semantic-models/$name_/propose-version'
    | '/_authed/metric-hub/drafts/$slug/$draftId/edit'
    | '/_authed/metric-hub/drafts/$slug/$draftId/'
    | '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/edit'
    | '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/resources': {
      id: '/_authed/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthedResourcesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mcp-setup': {
      id: '/_authed/mcp-setup'
      path: '/mcp-setup'
      fullPath: '/mcp-setup'
      preLoaderRoute: typeof AuthedMcpSetupRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/favorites': {
      id: '/_authed/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof AuthedFavoritesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboards': {
      id: '/_authed/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AuthedDashboardsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements': {
      id: '/_authed/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthedAnnouncementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/activity': {
      id: '/_authed/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthedActivityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/': {
      id: '/_authed/metric-hub/'
      path: '/metric-hub'
      fullPath: '/metric-hub/'
      preLoaderRoute: typeof AuthedMetricHubIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/sync-dashboard': {
      id: '/_authed/metric-hub/sync-dashboard'
      path: '/metric-hub/sync-dashboard'
      fullPath: '/metric-hub/sync-dashboard'
      preLoaderRoute: typeof AuthedMetricHubSyncDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/preview-access': {
      id: '/_authed/metric-hub/preview-access'
      path: '/metric-hub/preview-access'
      fullPath: '/metric-hub/preview-access'
      preLoaderRoute: typeof AuthedMetricHubPreviewAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/policy': {
      id: '/_authed/metric-hub/policy'
      path: '/metric-hub/policy'
      fullPath: '/metric-hub/policy'
      preLoaderRoute: typeof AuthedMetricHubPolicyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/onboarding': {
      id: '/_authed/metric-hub/onboarding'
      path: '/metric-hub/onboarding'
      fullPath: '/metric-hub/onboarding'
      preLoaderRoute: typeof AuthedMetricHubOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/my-drafts': {
      id: '/_authed/metric-hub/my-drafts'
      path: '/metric-hub/my-drafts'
      fullPath: '/metric-hub/my-drafts'
      preLoaderRoute: typeof AuthedMetricHubMyDraftsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/inbox': {
      id: '/_authed/metric-hub/inbox'
      path: '/metric-hub/inbox'
      fullPath: '/metric-hub/inbox'
      preLoaderRoute: typeof AuthedMetricHubInboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/health': {
      id: '/_authed/metric-hub/health'
      path: '/metric-hub/health'
      fullPath: '/metric-hub/health'
      preLoaderRoute: typeof AuthedMetricHubHealthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/graph': {
      id: '/_authed/metric-hub/graph'
      path: '/metric-hub/graph'
      fullPath: '/metric-hub/graph'
      preLoaderRoute: typeof AuthedMetricHubGraphRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/glossary': {
      id: '/_authed/metric-hub/glossary'
      path: '/metric-hub/glossary'
      fullPath: '/metric-hub/glossary'
      preLoaderRoute: typeof AuthedMetricHubGlossaryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/docs': {
      id: '/_authed/metric-hub/docs'
      path: '/metric-hub/docs'
      fullPath: '/metric-hub/docs'
      preLoaderRoute: typeof AuthedMetricHubDocsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/dashboard': {
      id: '/_authed/metric-hub/dashboard'
      path: '/metric-hub/dashboard'
      fullPath: '/metric-hub/dashboard'
      preLoaderRoute: typeof AuthedMetricHubDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/certificate': {
      id: '/_authed/metric-hub/certificate'
      path: '/metric-hub/certificate'
      fullPath: '/metric-hub/certificate'
      preLoaderRoute: typeof AuthedMetricHubCertificateRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/adoption': {
      id: '/_authed/metric-hub/adoption'
      path: '/metric-hub/adoption'
      fullPath: '/metric-hub/adoption'
      preLoaderRoute: typeof AuthedMetricHubAdoptionRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/webhook-logs': {
      id: '/_authed/admin/webhook-logs'
      path: '/admin/webhook-logs'
      fullPath: '/admin/webhook-logs'
      preLoaderRoute: typeof AuthedAdminWebhookLogsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/tokens': {
      id: '/_authed/admin/tokens'
      path: '/admin/tokens'
      fullPath: '/admin/tokens'
      preLoaderRoute: typeof AuthedAdminTokensRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/embeddings': {
      id: '/_authed/admin/embeddings'
      path: '/admin/embeddings'
      fullPath: '/admin/embeddings'
      preLoaderRoute: typeof AuthedAdminEmbeddingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/categories': {
      id: '/_authed/admin/categories'
      path: '/admin/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AuthedAdminCategoriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/atlas': {
      id: '/_authed/admin/atlas'
      path: '/admin/atlas'
      fullPath: '/admin/atlas'
      preLoaderRoute: typeof AuthedAdminAtlasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/semantic-models/': {
      id: '/_authed/metric-hub/semantic-models/'
      path: '/metric-hub/semantic-models'
      fullPath: '/metric-hub/semantic-models/'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/explore/': {
      id: '/_authed/metric-hub/explore/'
      path: '/metric-hub/explore'
      fullPath: '/metric-hub/explore/'
      preLoaderRoute: typeof AuthedMetricHubExploreIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/semantic-models/new': {
      id: '/_authed/metric-hub/semantic-models/new'
      path: '/metric-hub/semantic-models/new'
      fullPath: '/metric-hub/semantic-models/new'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/semantic-models/$name': {
      id: '/_authed/metric-hub/semantic-models/$name'
      path: '/metric-hub/semantic-models/$name'
      fullPath: '/metric-hub/semantic-models/$name'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsNameRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/metrics/new': {
      id: '/_authed/metric-hub/metrics/new'
      path: '/metric-hub/metrics/new'
      fullPath: '/metric-hub/metrics/new'
      preLoaderRoute: typeof AuthedMetricHubMetricsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/metrics/$slug': {
      id: '/_authed/metric-hub/metrics/$slug'
      path: '/metric-hub/metrics/$slug'
      fullPath: '/metric-hub/metrics/$slug'
      preLoaderRoute: typeof AuthedMetricHubMetricsSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/explore/$boardId': {
      id: '/_authed/metric-hub/explore/$boardId'
      path: '/metric-hub/explore/$boardId'
      fullPath: '/metric-hub/explore/$boardId'
      preLoaderRoute: typeof AuthedMetricHubExploreBoardIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/semantic-models/$name_/propose-version': {
      id: '/_authed/metric-hub/semantic-models/$name_/propose-version'
      path: '/metric-hub/semantic-models/$name/propose-version'
      fullPath: '/metric-hub/semantic-models/$name/propose-version'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsNameProposeVersionRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/drafts/$slug/$draftId': {
      id: '/_authed/metric-hub/drafts/$slug/$draftId'
      path: '/metric-hub/drafts/$slug/$draftId'
      fullPath: '/metric-hub/drafts/$slug/$draftId'
      preLoaderRoute: typeof AuthedMetricHubDraftsSlugDraftIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/drafts/$slug/$draftId/': {
      id: '/_authed/metric-hub/drafts/$slug/$draftId/'
      path: '/'
      fullPath: '/metric-hub/drafts/$slug/$draftId/'
      preLoaderRoute: typeof AuthedMetricHubDraftsSlugDraftIdIndexRouteImport
      parentRoute: typeof AuthedMetricHubDraftsSlugDraftIdRoute
    }
    '/_authed/metric-hub/drafts/$slug/$draftId/edit': {
      id: '/_authed/metric-hub/drafts/$slug/$draftId/edit'
      path: '/edit'
      fullPath: '/metric-hub/drafts/$slug/$draftId/edit'
      preLoaderRoute: typeof AuthedMetricHubDraftsSlugDraftIdEditRouteImport
      parentRoute: typeof AuthedMetricHubDraftsSlugDraftIdRoute
    }
    '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/': {
      id: '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/'
      path: '/metric-hub/semantic-models/$name/drafts/$draftId'
      fullPath: '/metric-hub/semantic-models/$name/drafts/$draftId/'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/edit': {
      id: '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/edit'
      path: '/metric-hub/semantic-models/$name/drafts/$draftId/edit'
      fullPath: '/metric-hub/semantic-models/$name/drafts/$draftId/edit'
      preLoaderRoute: typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedMetricHubDraftsSlugDraftIdRouteChildren {
  AuthedMetricHubDraftsSlugDraftIdEditRoute: typeof AuthedMetricHubDraftsSlugDraftIdEditRoute
  AuthedMetricHubDraftsSlugDraftIdIndexRoute: typeof AuthedMetricHubDraftsSlugDraftIdIndexRoute
}

const AuthedMetricHubDraftsSlugDraftIdRouteChildren: AuthedMetricHubDraftsSlugDraftIdRouteChildren =
  {
    AuthedMetricHubDraftsSlugDraftIdEditRoute:
      AuthedMetricHubDraftsSlugDraftIdEditRoute,
    AuthedMetricHubDraftsSlugDraftIdIndexRoute:
      AuthedMetricHubDraftsSlugDraftIdIndexRoute,
  }

const AuthedMetricHubDraftsSlugDraftIdRouteWithChildren =
  AuthedMetricHubDraftsSlugDraftIdRoute._addFileChildren(
    AuthedMetricHubDraftsSlugDraftIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedActivityRoute: typeof AuthedActivityRoute
  AuthedAnnouncementsRoute: typeof AuthedAnnouncementsRoute
  AuthedDashboardsRoute: typeof AuthedDashboardsRoute
  AuthedFavoritesRoute: typeof AuthedFavoritesRoute
  AuthedMcpSetupRoute: typeof AuthedMcpSetupRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedResourcesRoute: typeof AuthedResourcesRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAdminAtlasRoute: typeof AuthedAdminAtlasRoute
  AuthedAdminCategoriesRoute: typeof AuthedAdminCategoriesRoute
  AuthedAdminEmbeddingsRoute: typeof AuthedAdminEmbeddingsRoute
  AuthedAdminTokensRoute: typeof AuthedAdminTokensRoute
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
  AuthedAdminWebhookLogsRoute: typeof AuthedAdminWebhookLogsRoute
  AuthedMetricHubAdoptionRoute: typeof AuthedMetricHubAdoptionRoute
  AuthedMetricHubCertificateRoute: typeof AuthedMetricHubCertificateRoute
  AuthedMetricHubDashboardRoute: typeof AuthedMetricHubDashboardRoute
  AuthedMetricHubDocsRoute: typeof AuthedMetricHubDocsRoute
  AuthedMetricHubGlossaryRoute: typeof AuthedMetricHubGlossaryRoute
  AuthedMetricHubGraphRoute: typeof AuthedMetricHubGraphRoute
  AuthedMetricHubHealthRoute: typeof AuthedMetricHubHealthRoute
  AuthedMetricHubInboxRoute: typeof AuthedMetricHubInboxRoute
  AuthedMetricHubMyDraftsRoute: typeof AuthedMetricHubMyDraftsRoute
  AuthedMetricHubOnboardingRoute: typeof AuthedMetricHubOnboardingRoute
  AuthedMetricHubPolicyRoute: typeof AuthedMetricHubPolicyRoute
  AuthedMetricHubPreviewAccessRoute: typeof AuthedMetricHubPreviewAccessRoute
  AuthedMetricHubSyncDashboardRoute: typeof AuthedMetricHubSyncDashboardRoute
  AuthedMetricHubIndexRoute: typeof AuthedMetricHubIndexRoute
  AuthedMetricHubExploreBoardIdRoute: typeof AuthedMetricHubExploreBoardIdRoute
  AuthedMetricHubMetricsSlugRoute: typeof AuthedMetricHubMetricsSlugRoute
  AuthedMetricHubMetricsNewRoute: typeof AuthedMetricHubMetricsNewRoute
  AuthedMetricHubSemanticModelsNameRoute: typeof AuthedMetricHubSemanticModelsNameRoute
  AuthedMetricHubSemanticModelsNewRoute: typeof AuthedMetricHubSemanticModelsNewRoute
  AuthedMetricHubExploreIndexRoute: typeof AuthedMetricHubExploreIndexRoute
  AuthedMetricHubSemanticModelsIndexRoute: typeof AuthedMetricHubSemanticModelsIndexRoute
  AuthedMetricHubDraftsSlugDraftIdRoute: typeof AuthedMetricHubDraftsSlugDraftIdRouteWithChildren
  AuthedMetricHubSemanticModelsNameProposeVersionRoute: typeof AuthedMetricHubSemanticModelsNameProposeVersionRoute
  AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute: typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute
  AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute: typeof AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedActivityRoute: AuthedActivityRoute,
  AuthedAnnouncementsRoute: AuthedAnnouncementsRoute,
  AuthedDashboardsRoute: AuthedDashboardsRoute,
  AuthedFavoritesRoute: AuthedFavoritesRoute,
  AuthedMcpSetupRoute: AuthedMcpSetupRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedResourcesRoute: AuthedResourcesRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAdminAtlasRoute: AuthedAdminAtlasRoute,
  AuthedAdminCategoriesRoute: AuthedAdminCategoriesRoute,
  AuthedAdminEmbeddingsRoute: AuthedAdminEmbeddingsRoute,
  AuthedAdminTokensRoute: AuthedAdminTokensRoute,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
  AuthedAdminWebhookLogsRoute: AuthedAdminWebhookLogsRoute,
  AuthedMetricHubAdoptionRoute: AuthedMetricHubAdoptionRoute,
  AuthedMetricHubCertificateRoute: AuthedMetricHubCertificateRoute,
  AuthedMetricHubDashboardRoute: AuthedMetricHubDashboardRoute,
  AuthedMetricHubDocsRoute: AuthedMetricHubDocsRoute,
  AuthedMetricHubGlossaryRoute: AuthedMetricHubGlossaryRoute,
  AuthedMetricHubGraphRoute: AuthedMetricHubGraphRoute,
  AuthedMetricHubHealthRoute: AuthedMetricHubHealthRoute,
  AuthedMetricHubInboxRoute: AuthedMetricHubInboxRoute,
  AuthedMetricHubMyDraftsRoute: AuthedMetricHubMyDraftsRoute,
  AuthedMetricHubOnboardingRoute: AuthedMetricHubOnboardingRoute,
  AuthedMetricHubPolicyRoute: AuthedMetricHubPolicyRoute,
  AuthedMetricHubPreviewAccessRoute: AuthedMetricHubPreviewAccessRoute,
  AuthedMetricHubSyncDashboardRoute: AuthedMetricHubSyncDashboardRoute,
  AuthedMetricHubIndexRoute: AuthedMetricHubIndexRoute,
  AuthedMetricHubExploreBoardIdRoute: AuthedMetricHubExploreBoardIdRoute,
  AuthedMetricHubMetricsSlugRoute: AuthedMetricHubMetricsSlugRoute,
  AuthedMetricHubMetricsNewRoute: AuthedMetricHubMetricsNewRoute,
  AuthedMetricHubSemanticModelsNameRoute:
    AuthedMetricHubSemanticModelsNameRoute,
  AuthedMetricHubSemanticModelsNewRoute: AuthedMetricHubSemanticModelsNewRoute,
  AuthedMetricHubExploreIndexRoute: AuthedMetricHubExploreIndexRoute,
  AuthedMetricHubSemanticModelsIndexRoute:
    AuthedMetricHubSemanticModelsIndexRoute,
  AuthedMetricHubDraftsSlugDraftIdRoute:
    AuthedMetricHubDraftsSlugDraftIdRouteWithChildren,
  AuthedMetricHubSemanticModelsNameProposeVersionRoute:
    AuthedMetricHubSemanticModelsNameProposeVersionRoute,
  AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute:
    AuthedMetricHubSemanticModelsNameDraftsDraftIdEditRoute,
  AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute:
    AuthedMetricHubSemanticModelsNameDraftsDraftIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
